var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header-logo"},[_c('router-link',{attrs:{"to":"/","dark":""}},[_c('h1',{staticClass:"header-logo__logo"},[_c('span',[_vm._v("TRICTO")]),_vm._v(" "),_c('span',[_vm._v("SAMURAI")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }